export { LiveReportDetailsTemplate } from "./LiveReportDetailsTemplate"
export type { LiveReportDetailsTemplateProps } from "./LiveReportDetailsTemplate"
